// @flow

// Vendors
import React, { useState } from 'react';

// Components
import { Form, FormField, FormSubmit, Notice } from '..';

// Requests
import { forgotPasswordRequest } from '../../requests';

const ForgotPasswordForm = () => {
  const [success, setSuccess] = useState('');

  const initialValues = {
    email: ''
  };

  const handleSubmit = ({
    values,
    errors,
    setValues,
    setErrors,
    setSubmitting
  }) => {
    setSubmitting(true);

    forgotPasswordRequest(values)
      .then(({ data }) => {
        setSubmitting(false);
        setSuccess(
          'A link to reset your password has been sent to the email address provided.'
        );
      })
      .catch(({ data }) => {
        setSubmitting(false);
        if (data.errors) setErrors(data.errors);
      });
  };

  return (
    <Form
      className="card u--squash"
      onSubmit={handleSubmit}
      initialValues={initialValues}
      render={({ values, errors, isSubmitting, setError, handleChange }) => (
        <>
          <div className="card__body">
            <p>
              Please enter your email address. You will receive a link to create
              a new password via email.
            </p>
            <FormField
              name="email"
              label="Email Address"
              onChange={handleChange}
              value={values.email}
              error={errors.email}
              disabled={isSubmitting}
            />
            <FormSubmit
              loading={isSubmitting}
              disabled={isSubmitting}
              disabledLabel={
                isSubmitting && !success ? 'Submitting...' : 'Submit'
              }
            />
            {errors.formError && (
              <Notice
                type="danger"
                message={errors.formError}
                dismiss={() => setError('formError', '')}
              />
            )}
            {success && (
              <Notice
                type="success"
                message={success}
                dismiss={() => setSuccess('')}
              />
            )}
          </div>

          <div className="card__footer">
            <a href="/resource-center/login">Back to Login</a>
          </div>
        </>
      )}
    />
  );
};

export default ForgotPasswordForm;
